import { Box, Stack, Typography } from "@mui/material";
import { TooltipContentDivider } from "../../shared/views";
import { portfolioPerformanceService } from "../../../shared/services/PortfolioPerformanceService";

type PortfolioBalanceTooltipContentProps = {
    roi: number | null;
    annualisedRoi: number | null;
};

export function PortfolioBalanceTooltipContent({
    roi,
    annualisedRoi,
}: PortfolioBalanceTooltipContentProps) {
    const textSx = {
        fontSize: "inherit",
    };

    return (
        <Stack>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: "60px 60px",
                    columnGap: "10px",
                    rowGap: 0,
                    fontSize: "13px",
                }}
            >
                <Typography sx={{ ...textSx, fontWeight: "bold" }}>Metric</Typography>
                <Typography sx={{ ...textSx, fontWeight: "bold" }} textAlign="right">Value</Typography>
            </Box>
            <TooltipContentDivider />
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: "60px 60px",
                    columnGap: "10px",
                    rowGap: 0,
                    fontSize: "13px",
                }}
            >
                <Typography sx={textSx}>ROI</Typography>
                <Typography sx={textSx} textAlign="right">
                    {portfolioPerformanceService.formatPercentage(roi)}
                </Typography>
                <Typography sx={textSx}>AROI</Typography>
                <Typography sx={textSx} textAlign="right">
                    {portfolioPerformanceService.formatPercentage(annualisedRoi)}
                </Typography>
            </Box>
        </Stack>
    );
}
